/*
Author: Chaitanya
*/

import React, { useState } from 'react';
import SelectBox from '@components/form/SelectBox';

import useApi from '@/hooks/useApi';
import { MsAccount } from '@api/ms-account';
import PropTypes from 'prop-types';

const propTypes = {
  editable: PropTypes.bool,
  isRequired: PropTypes.bool,
  multiple: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func,
  hideLabel: PropTypes.bool,
  inputContainerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
  hideSearch: PropTypes.bool,
};

const defaultProps = {
  editable: true,
  isRequired: false,
  multiple: false,
  hasError: false,
  onChange: () => {},
  hideLabel: false,
  inputContainerStyle: {},
  value: '',
  hideSearch: false,
};

const limit = 10;

const PaymentTermsSearch = (props) => {
  const {
    editable = true,
    isRequired = false,
    multiple = false,
    hasError = false,
    hideLabel = false,
    inputContainerStyle = {},
    value = '',
    hideSearch = false,
  } = props;

  const [loading, setLoading] = useState({
    initial: false,
    loadMore: false,
  });
  const [options, setOptions] = useState([]);
  const [skip, setSkip] = useState(0);

  const paymentTerms = useApi(MsAccount.getPaymentTerms);

  const onSearch = async (val, newSkip = 0) => {
    if (newSkip) {
      setLoading({ ...loading, loadMore: true });
    } else {
      setLoading({ ...loading, initial: true });
    }
    try {
      const filter = {};
      if (val) {
        filter.name = { $regex: val, $options: 'i' };
      }
      if (!val && filter.name) {
        delete filter.name;
      }
      const response = await paymentTerms.request({
        params: {
          filter: filter,
          skip: newSkip,
          limit: limit,
        },
      });
      if (response.status == 200 && response?.data?.data?.length) {
        const result = response.data.data.map((item) => {
          return {
            id: item.id,
            name: item.name,
          };
        });
        if (newSkip) {
          setOptions(options.concat(result));
        } else {
          setOptions(result);
        }
      } else {
        if (!newSkip) {
          setOptions([]);
        }
      }

      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    } catch (error) {
      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    }
  };

  return (
    <SelectBox
      {...props}
      label="Payment Terms"
      options={options}
      value={value}
      placeholder={
        loading.initial || loading.loadMore
          ? 'Loading...'
          : 'Select Payment terms'
      }
      trackBy="id"
      labelKey="name"
      isRequired={isRequired}
      multiple={multiple}
      editable={editable && !loading.initial}
      hideLabel={hideLabel}
      inputContainerStyle={inputContainerStyle}
      hasError={hasError}
      loading={loading.initial}
      loadingCallback={loading.loadMore}
      withCallback={true}
      withLoadMore={true}
      hideSearch={hideSearch}
      loadMoreEmpty={skip >= options.length}
      searchCallback={(val) => {
        setSkip(0);
        onSearch(val);
      }}
      onLoadMore={(val) => {
        const newSkip = skip + 10;
        setSkip(newSkip);
        onSearch(val, newSkip);
      }}
      onChange={(val) => {
        props.onChange(val);
      }}
      onReady={() => {
        setSkip(0);
        onSearch();
      }}
    />
  );
};

PaymentTermsSearch.propTypes = propTypes;
PaymentTermsSearch.defaultProps = defaultProps;

export default PaymentTermsSearch;
